import { mutatorAction } from "satcheljs";
import { shiftRequestStore } from "../";

export default mutatorAction('SET_ARE_ALL_ACTIVE_REQUESTS_LOADED', function setAreAllActiveRequestsLoadedInStore(isDataLoaded: boolean) {
    shiftRequestStore().areAllActiveRequestsLoaded = isDataLoaded;
});
